import { Wrapper } from 'AppReact';
import styled from 'styled-components';

const template = styled.div`
  width: 100%;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.07);
  z-index: 2;
`

export default Wrapper(template);